// the plan item shape the bot's live derivation reads (subset of the rebalancing plan item)
export interface FactorInputItem {
  currentPercent: number
  targetPercent: number
  currentPrice: number
  averagePrice: number | null
  lotSize: number | null
}

// derives the plan-driven dip-pipeline inputs exactly as the live bot does (see
// bot-session-manager setDisproportion). mood/desire are config dials, not derived here.
// disproportion is null when there is no plan item (the live bot coerces it to 0 where its
// not-in-plan path needs a number). freeCash carries the user-set spendable budget
// (freeAmount); accountCash carries the real account balance (availableCash).
export function deriveFactorInputs(
  item: FactorInputItem | null,
  availableCash: number | null,
  freeAmount: number | null
): {
  disproportion: number | null
  avgCostDistance: number | null
  freeCash: number | null
  accountCash: number | null
  lotPrice: number | null
} {
  // signed deviation (overweight > 0, underweight < 0)
  const disproportion = item ? item.currentPercent - item.targetPercent : null
  // pctDiff(price, avgCost): how far live price sits above/below the held avg cost
  const avgCostDistance =
    item && item.averagePrice != null && item.averagePrice > 0
      ? ((item.currentPrice - item.averagePrice) / item.averagePrice) * 100
      : null
  // one-lot notional: lotSize * price
  const lotPrice = item && item.lotSize != null ? item.currentPrice * item.lotSize : null
  return {
    disproportion,
    avgCostDistance,
    freeCash: freeAmount,
    accountCash: availableCash,
    lotPrice,
  }
}
